import { createSelector } from 'reselect';

import getActiveLocale from './getActiveLocale';

export default createSelector(getActiveLocale, (locale) => (copy) => copy[locale] || copy['en-gb'] || copy.uk);
